import { useSelector } from 'react-redux';

export default function useDataSet() {
  const dataSets = useSelector((state: any) => state.entities.dataSets);

  function getDataSetById(id: number) {
    return dataSets[id];
  }

  return {
    getDataSetById,
    dataSets,
  };
}
